import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";

/**
 * Indicador global de progreso de scroll — 1.5px, top:0, transform-only.
 * pointer-events: none. Se oculta en reduced-motion. Ancho reservado con
 * transform:scaleX (nunca cambia layout).
 */
export default function ScrollProgress() {
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 160,
    damping: 32,
    mass: 0.25,
  });
  if (reduce) return null;
  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden="true"
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="pointer-events-none fixed inset-x-0 top-0 z-[100] h-[1.5px] origin-left bg-[#111]/50 backdrop-blur-[1px]"
    />
  );
}
